import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import ScrollAnimation from 'react-animate-on-scroll';
import RoundSection from './RoundSection';
import './styles.css';

function LayoutRoundRow(props) {
  if (!props.content) return null;
  return (
    <Container>
      <Row>
        {props.content.column.map((section, index) => (
          <Col xs="12" key={index} md="4" className={'round-section-highlight'}>
            <ScrollAnimation
              animateIn="fadeInUp"
              animateOut="fadeOutUp"
              delay={(index-.5) * 50}
            >
              <RoundSection content={section} />
            </ScrollAnimation>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default LayoutRoundRow;
